/**
 * @name logout
 * @param oktaAuth object provided by the Okta SDK
 * @desc Logs the user out from Okta session
 */
const logout = async oktaAuth => {
  if (!oktaAuth) return;

  sessionStorage.removeItem('deepLink');
  localStorage.clear();
  document.cookie = 'NikeGamedayToken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT'; // Remove iPaid token on logout
  await oktaAuth.closeSession();
  await oktaAuth.revokeAccessToken();
  window.location.reload();
};

export default logout;
